const MODERN_SUPPORTED_PATHS = new Set(['', '/']);

const normalizePathname = (pathname: string) =>
  pathname.length > 1 && pathname.endsWith('/')
    ? pathname.slice(0, -1)
    : pathname;

export const isModernRouteSupported = (pathname: string) =>
  MODERN_SUPPORTED_PATHS.has(normalizePathname(pathname));
